import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import { msalConfig } from '@gtintel/signin/config/authConfig';
import { AuthProvider } from '@gtintel/signin/contexts/AuthContext';
import { AuthCallback } from '@gtintel/signin/pages/AuthCallback';
import { Login } from '@gtintel/signin/pages/Login';
import { MFASetup } from '@gtintel/signin/pages/MFASetup';
import { MFAVerify } from '@gtintel/signin/pages/MFAVerify';
import { Redirect } from '@gtintel/signin/pages/Redirect';
import { RedirectSelection } from '@gtintel/signin/pages/RedirectSelection';

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <Router>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <Routes>
            {/* Regular user routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/mfa/verify" element={<MFAVerify />} />
            <Route path="/mfa/setup" element={<MFASetup />} />
            <Route path="/redirect" element={<Redirect />} />
            <Route path="/apps" element={<RedirectSelection />} />

            {/* Auth callback for admin Azure B2C */}
            <Route path="/admin/auth/callback/azure-ad-b2c" element={<AuthCallback />} />

            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </AuthProvider>
      </MsalProvider>
    </Router>
  );
}

export default App;
